import { useState } from 'react';
import Button from '@components/Button';
import ClientForm from '../../partials/form/ClientForm';
import ModalDerived from './partials/ModalDerived';

const ContentStep1 = (props) => {
  const [open, setOpen] = useState(false)
  const [emailValidate, setEmailValidate] = useState(false)

  // Fix 2026-06-08: valida o e-mail INLINE (por formato) em vez de depender do flag
  // emailValidate, que só virava true no onBlur do campo. Quando o cliente era
  // carregado/preenchido sem dar blur no e-mail, o botão "Continuar para pagamento"
  // ficava travado mesmo com tudo preenchido.
  const isValidEmail = (e) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((e || '').trim())
  // Fix 2026-06-08: conta DÍGITOS do telefone em vez de length da string (que dependia
  // da máscara). Telefone salvo só com dígitos (ex: "5522996050409"=13) reprovava no
  // `length > 14` e travava o botão mesmo com tudo preenchido.
  const phoneOk = (p) => (p || '').replace(/\D/g, '').length >= 10

  const idDisabled = () => {
    const client = props.client
    if (client.email && isValidEmail(client.email) && client.document && client.name && phoneOk(client.phone) && !client.derived) {
      if (props.type === "cart" || props.type === "transfer" && (props.client.addresses?.length)) {
        return false
      }
      if (props.type === "tour" || props.type === "combo" && client.addresses.length && (client?.addresses[0]?.hotel || client?.addresses[1]?.hotel) && (client?.addresses[0]?.hotel_address || client?.addresses[1]?.hotel_address)) {
        return false
      }
    } else if (client.partnerEmail && client.email && phoneOk(client.phone) && client.addresses.length) {
      return false
    }
    return true
  }

  const openModal = () => {
    const client = props.client
    if (client.partnerEmail === client.email) {
      setOpen(true)
    } else {
      props.changeStep(2)
    }
  }

  const isDerived = (confirm) => {
    if (confirm) {
      props.changeClient({
        target: {
          name: 'derived',
          value: confirm
        }
      })
      props.changeStep(2)
    } else {
      const data = {
        derived: confirm,
        email: ''
      }
      props.notDerived(data)
    }
  }
  return <>
    <div className="mt-4 font-poppins" style={{ borderRadius: '10px', backgroundColor: '#172B4D', color: '#e8f0fb' }}>
      <ClientForm
        client={props.client}
        reserve={props.reserve}
        changeReserve={props.changeReserve}
        clientEmail={props.reservationData?.cart[0]?.customer_email || props.customerEmail}
        regionsTravel={props.regionsTravel}
        changeClientByEmail={props.changeClientByEmail}
        changeClientByPartner={props.changeClientByPartner}
        changeClient={props.changeClient}
        changeClientAddress={props.changeClientAddress}
        changeObservations={props.changeObservations}
        onlyLetterAndNumber={props.onlyLetterAndNumber}
        changeClientCheckbox={props.changeClientCheckbox}
        changeSetEmail={setEmailValidate}
      />
      <ModalDerived
        open={open}
        close={() => setOpen(false)}
        isDerived={isDerived}
      />
    </div>
    <div className="flex space-x-5 justify-end mb-4">
      <Button
        textcolor="#e8f0fb"
        padding="6px 15px"
        width="100px"
        variant="outlined"
        onClick={props.backPage}
        bgColor="transparent"
      >
        Voltar
      </Button>
      <Button
        disabled={idDisabled()}
        textcolor="#fff"
        padding="6px 15px"
        width="260px"
        onClick={() => openModal()}
        customcolor={props.theme.color}
      >
        Continuar para pagamento
      </Button>
    </div>
  </>
}

export default ContentStep1;